import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { fillScope } from '@customerio/pluma-components/css/utils';

export const suggestionButton = style(
  {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 8px',
    borderRadius: themeVars.radius['4'],
    cursor: 'pointer',
    background: fillScope('neutral', 'subtle'),
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    color: themeVars.color['text-primary'],
    fontSize: themeVars['font-size']['xs'],
    fontWeight: themeVars['font-weight']['medium'],
    whiteSpace: 'nowrap',

    ':focus': {
      outline: 'none',
    },

    ':focus-visible': {
      boxShadow: themeVars.focus['default'],
    },
  },
  'suggestion-button',
);
